import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

import {
  Navbar,
  NavBody,
  MobileNav,
  NavbarLogo,
  NavbarButton,
  MobileNavHeader,
  MobileNavToggle,
  MobileNavMenu,
} from "./ui/resizable-navbar";

export default function NavbarDemo() {
  const navigate = useNavigate();

  const navItems = [
    { name: "Home", link: "/" },
    { name: "About", link: "/about" },
    { name: "Institute", link: "/institute" },
    { name: "Technology", link: "/technology" },
    {
      name: "Blogs",
      link: "/blog",
    },
    { name: "Contact", link: "/contact" },
  ];

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <Navbar>
      {/* Desktop Navbar */}
      <NavBody>
        <NavbarLogo />

        <div className="flex items-center gap-1">
          {navItems.map((item) => (
            <NavLink
              key={item.name}
              to={item.link}
              className={({ isActive }) =>
                `
                rounded-lg
                px-4
                py-2
                text-sm
                font-medium
                transition-all
                ${
                  isActive
                    ? "bg-neutral-100 text-black"
                    : "text-neutral-600 hover:bg-neutral-50 hover:text-black"
                }
                `
              }
            >
              {item.name}
            </NavLink>
          ))}
        </div>

        <div className="relative z-20 flex items-center gap-3">
          <NavbarButton
            variant="primary"
            onClick={() => navigate("/contact")}
          >
            Get Started
          </NavbarButton>
        </div>
      </NavBody>

      {/* Mobile Navbar */}
      <MobileNav>
        <MobileNavHeader>
          <NavbarLogo />

          <MobileNavToggle
            isOpen={isMobileMenuOpen}
            onClick={() =>
              setIsMobileMenuOpen((prev) => !prev)
            }
          />
        </MobileNavHeader>

        <MobileNavMenu isOpen={isMobileMenuOpen}>
          {navItems.map((item) => (
            <NavLink
              key={item.name}
              to={item.link}
              onClick={() => setIsMobileMenuOpen(false)}
              className={({ isActive }) =>
                `
                w-full
                rounded-xl
                px-3
                py-3
                text-sm
                font-medium
                transition
                ${
                  isActive
                    ? "bg-neutral-100 text-black"
                    : "text-neutral-700 hover:bg-neutral-100 hover:text-black"
                }
                `
              }
            >
              {item.name}
            </NavLink>
          ))}

          <NavbarButton
            variant="primary"
            className="mt-2 w-full"
            onClick={() => {
              setIsMobileMenuOpen(false);
              navigate("/contact");
            }}
          >
            Get Started
          </NavbarButton>
        </MobileNavMenu>
      </MobileNav>
    </Navbar>
  );
}